<template>
    <div>
        <!-- <video id="video" style="position: absolute; object-fit: cover; object-position: center center; height: 100%; width: 100%;" src="https://des.cloud.tencent.com/tencent-ai/video.mp4" preload="auto" webkit-playsinline="webkit-playsinline" playsinline="playsinline" x5-playsinline="x5-playsinline" x-webkit-airplay="true" airplay="allow" poster=""></video> -->
        <div style="height: 100vh;" v-show="videoShow">
            <video id="video" ref="video" style="position: absolute; object-fit: cover; object-position: center center; height: 100%; width: 100%;" src="https://des.cloud.tencent.com/tencent-ai/video.mp4" 
            preload="auto" webkit-playsinline="webkit-playsinline" playsinline="playsinline" x5-playsinline="x5-playsinline" x-webkit-airplay="true" airplay="allow" poster=""></video>
        </div>
        
        <button @click="play" v-show="!videoShow" id="btn">点击</button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            videoShow: false
        }
    },
    methods: {
        play() {
            this.videoShow = true
            document.getElementById('video').play()
        }
    }
}
</script>